<script>
  import { getContext } from 'svelte';
  import FixedContent from '../FixedContent/FixedContent.svelte';
  import ContentBox from '../ContentBox/ContentBox.svelte';
  import ProfileCard from '../ProfileCard/ProfileCard.svelte';
  import Button from '../Button/Button.svelte';
  import { getPlayerInfo, getPlayerStats } from '../utils/api.js';

  export let home = false;
  export let slim = false;

  const state = getContext('state');

  const checkForUrlProp = () => {
    const props = window.location.search.replace(/\?/, '').split('=');
    if (props[0] === 'nickname' && window.location.hash === '') {
      $state.nickname = props[1];

      if (!$state.disableEvents) {
        gtag('event', 'From Share Link', {
          'event_category': $state.nickname
        });
      }

      window.location.hash = 'loaded';
      getProfileData();
    }
  };

  const getProfileData = async () => {
    $state.loading.playerData = true;
    $state.data.playerData = null;
    $state.data.playerData = await getPlayerInfo($state.nickname);
    //console.log($state.data.playerData);
    $state.data.playerStats = await getPlayerStats($state.data.playerData.player_id);
    //console.log($state.data.playerStats);
    $state.loading.playerData = false;

    if (!$state.data.playerData.errors && !$state.data.playerStats.errors) {
      if (!$state.disableEvents) {
        gtag('event', 'Load Profile', {
          'event_category': $state.nickname
        });
      }
    }
  };

  if (home) {
    checkForUrlProp();
    //getProfileData();
  }
</script>

<div class="md:flex  items-center  justify-center">
  <div class="text-center md:text-left md:flex  items-center">
    <form class="md:flex  items-center" on:submit={(e) => { e.preventDefault(); getProfileData(); }}>
      <label class="mr-2  text-gray-700  {slim ? 'text-base' : 'text-lg'}">FACEIT Username</label>
      <input type="text" class="text-black  focus:outline-none  {slim ? '' : 'px-4  py-2  text-2xl'}" bind:value={$state.nickname} />
    </form>

    <div class="my-2  ml-2">
      <Button size="{slim ? '' : 'lg'}" text={$state.loading.playerData ? 'Loading...' : 'Load profile'} onClick={getProfileData} />
    </div>
  </div>
</div>
{#if ($state.data.playerData && $state.data.playerData.errors) || ($state.data.playerStats && $state.data.playerStats.errors)}
  <div class="text-xs">There's been an issue retrieving data for that nickname, please check it's correct and is case sensitive.</div>
{/if}
